export default "__VITE_ASSET__C7jg5dpt__"